/* ═══════════════════════════════════════════════════════════
   LAYOUT SHELL — Sidebar, TopBar, BottomTabBar, UpgradePrompt
   ═══════════════════════════════════════════════════════════ */

/* ─── Sidebar ─── */
.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 240px;
  background: #0A0E1A;
  border-right: 1px solid rgba(255, 255, 255, 0.04);
}

.sidebarLogo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  flex-shrink: 0;
}

.sidebarLogoIcon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0A0E1A;
}

.sidebarLogoText {
  display: flex;
  flex-direction: column;
}

.sidebarLogoName {
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.1;
  letter-spacing: -0.01em;
}

.sidebarLogoSub {
  color: #555C72;
  font-size: 10px;
  line-height: 1.2;
}

.sidebarCloseBtn {
  margin-left: auto;
  background: none;
  border: none;
  color: #555C72;
  cursor: pointer;
  padding: 4px;
  transition: color 0.15s ease;
}

.sidebarCloseBtn:hover { color: #CBD5E1; }

/* User section */
.sidebarUser {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.sidebarAvatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(0, 210, 106, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #00D26A;
  text-transform: uppercase;
  flex-shrink: 0;
}

.sidebarUserInfo {
  flex: 1;
  min-width: 0;
}

.sidebarUserName {
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebarUserTier {
  font-size: 10px;
  color: #555C72;
  text-transform: capitalize;
}

/* Nav */
.sidebarNav {
  flex: 1;
  overflow-y: auto;
  padding: 12px 8px;
}

.sidebarNav::-webkit-scrollbar { width: 3px; }
.sidebarNav::-webkit-scrollbar-track { background: transparent; }
.sidebarNav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.05); border-radius: 3px; }

.navGroup {
  margin-bottom: 20px;
}

.navGroupTitle {
  padding: 0 12px;
  margin-bottom: 6px;
  font-size: 10px;
  font-weight: 600;
  color: #555C72;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.navItem {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 500;
  color: #8B92A8;
  text-decoration: none;
  transition: all 0.15s ease;
  border: none;
  background: none;
  width: 100%;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
}

.navItem:hover {
  color: #CBD5E1;
  background: rgba(255, 255, 255, 0.03);
}

.navItemActive {
  color: #00D26A;
  background: rgba(0, 210, 106, 0.06);
}

.navItemIcon {
  flex-shrink: 0;
  color: #555C72;
  transition: color 0.15s ease;
}

.navItemActive .navItemIcon {
  color: #00D26A;
}

.navItem:hover .navItemIcon {
  color: #8B92A8;
}

.navItemLabel {
  flex: 1;
}

.navItemBadge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 6px;
  background: rgba(0, 210, 106, 0.1);
  color: #00D26A;
  line-height: 1;
}

.navItemLocked {
  color: #3A3F52;
  cursor: not-allowed;
}

.navItemLocked .navItemIcon {
  opacity: 0.4;
}

.navItemLockIcon {
  flex-shrink: 0;
  opacity: 0.4;
}

/* Sign out */
.sidebarFooter {
  flex-shrink: 0;
  padding: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
}

.signOutBtn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  width: 100%;
  border-radius: 10px;
  font-size: 13px;
  font-family: inherit;
  color: #555C72;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.signOutBtn:hover {
  color: #EF4444;
  background: rgba(239, 68, 68, 0.06);
}

/* ─── TopBar (Mobile) ─── */
.topBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 16px;
  background: #0A0E1A;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  flex-shrink: 0;
  backdrop-filter: blur(12px);
}

.topBarBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: none;
  color: #8B92A8;
  cursor: pointer;
  transition: all 0.15s ease;
}

.topBarBtn:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.04);
}

.topBarLogo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.topBarLogoIcon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0A0E1A;
}

.topBarLogoText {
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: -0.01em;
}

.topBarRight {
  display: flex;
  align-items: center;
  gap: 4px;
}

.topBarNotifBadge {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 9999px;
  background: #00D26A;
  color: #0A0E1A;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
}

.topBarAvatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 210, 106, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #00D26A;
  text-transform: uppercase;
  margin-left: 4px;
}

/* ─── BottomTabBar ─── */
.bottomBar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  background: #0A0E1A;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  padding-bottom: env(safe-area-inset-bottom);
}

.bottomTab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 8px 0;
  font-size: 10px;
  font-weight: 500;
  font-family: inherit;
  color: #555C72;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.15s ease;
}

.bottomTabActive {
  color: #00D26A;
}

.bottomTabAI {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
}

.bottomTabAIBtn {
  width: 56px;
  height: 56px;
  margin-top: -20px;
  border-radius: 50%;
  background: #00D26A;
  color: #0A0E1A;
  font-family: 'Syne', sans-serif;
  font-weight: 900;
  font-size: 14px;
  letter-spacing: 0.05em;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0, 210, 106, 0.35);
  transition: all 0.2s ease;
}

.bottomTabAIBtn:hover {
  background: #00E676;
  box-shadow: 0 6px 28px rgba(0, 210, 106, 0.45);
  transform: scale(1.05);
}

.bottomTabAILabel {
  font-size: 10px;
  font-weight: 500;
  color: #555C72;
  margin-top: 4px;
}

/* ─── More Sheet ─── */
.moreBackdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.5);
}

.moreSheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background: #0A0E1A;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 20px 20px 0 0;
  transition: transform 0.3s ease-out;
  padding-bottom: env(safe-area-inset-bottom);
}

.moreSheetOpen { transform: translateY(0); }
.moreSheetClosed { transform: translateY(100%); }

.moreHandle {
  display: flex;
  justify-content: center;
  padding: 12px 0 4px;
}

.moreHandleBar {
  width: 40px;
  height: 4px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.08);
}

.moreHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.moreHeaderTitle {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.moreCloseBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: none;
  background: none;
  color: #555C72;
  cursor: pointer;
  transition: all 0.15s ease;
}

.moreCloseBtn:hover {
  color: #CBD5E1;
  background: rgba(255, 255, 255, 0.04);
}

.moreItems {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2px;
  padding: 12px;
  max-height: 60vh;
  overflow-y: auto;
}

.moreItem {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  font-size: 13.5px;
  font-weight: 500;
  font-family: inherit;
  color: #8B92A8;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  width: 100%;
  transition: all 0.15s ease;
}

.moreItem:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.03);
}

.moreItemIcon {
  flex-shrink: 0;
  color: #555C72;
}

.moreItemLabel {
  flex: 1;
}

.moreItemBadge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 6px;
  background: rgba(0, 210, 106, 0.1);
  color: #00D26A;
}

.moreItemChevron {
  flex-shrink: 0;
  color: #555C72;
}

.moreUserRow {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
}

/* ─── Upgrade Prompt ─── */
.upgradeCompact {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(0,210,106,0.06) 0%, rgba(123,92,250,0.04) 100%);
  border: 1px solid rgba(0, 210, 106, 0.15);
}

.upgradeCompactTitle {
  font-size: 13.5px;
  font-weight: 500;
  color: #fff;
}

.upgradeCompactSub {
  font-size: 12px;
  color: #8B92A8;
}

.upgradeCompactBtn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 100%);
  color: #0A0E1A;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.upgradeCompactBtn:hover {
  box-shadow: 0 2px 12px rgba(0, 210, 106, 0.2);
}

.upgradeFull {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(135deg, #0F1424 0%, #0F1424 80%, rgba(0,210,106,0.03) 100%);
  border: 1px solid rgba(0, 210, 106, 0.12);
  padding: 24px;
}

.upgradeGlow1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 256px;
  height: 256px;
  background: rgba(0, 210, 106, 0.04);
  border-radius: 50%;
  filter: blur(48px);
  pointer-events: none;
}

.upgradeGlow2 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 192px;
  height: 192px;
  background: rgba(123, 92, 250, 0.04);
  border-radius: 50%;
  filter: blur(48px);
  pointer-events: none;
}

.upgradeInner {
  position: relative;
  z-index: 1;
}

.upgradeDismiss {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: none;
  background: none;
  color: #555C72;
  cursor: pointer;
  transition: all 0.15s ease;
}

.upgradeDismiss:hover {
  color: #CBD5E1;
  background: rgba(255, 255, 255, 0.04);
}

.upgradeLockIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  margin-bottom: 16px;
}

.upgradeTitle {
  color: #fff;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 4px;
}

.upgradeDesc {
  color: #8B92A8;
  font-size: 13.5px;
  margin-bottom: 16px;
  line-height: 1.5;
}

.upgradeTierRow {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.upgradeTierBadge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.upgradeFeatures {
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.upgradeFeatureItem {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13.5px;
  color: #8B92A8;
}

.upgradeFeatureDot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.upgradeFeatureDotInner {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.upgradeCTA {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 0;
  border-radius: 14px;
  font-weight: 600;
  font-size: 14px;
  font-family: inherit;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 100%);
  color: #0A0E1A;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 20px rgba(0, 210, 106, 0.2);
}

.upgradeCTA:hover {
  box-shadow: 0 6px 28px rgba(0, 210, 106, 0.3);
  transform: translateY(-1px);
}

.upgradeFootnote {
  text-align: center;
  font-size: 12px;
  color: #555C72;
  margin-top: 12px;
}

/* ─── AppShell ─── */
.appShell {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #0F1424;
  overflow: hidden;
}

.appMain {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.desktopSidebar {
  display: none;
  flex-shrink: 0;
}

@media (min-width: 1024px) {
  .desktopSidebar { display: flex; }
  .topBar { display: none; }
  .bottomBar { display: none; }
}

/* Responsive helpers */
.desktopOnly { display: none; }
.mobileOnly { display: block; }

@media (min-width: 1024px) {
  .desktopOnly { display: block; }
  .mobileOnly { display: none; }
}

.mobileDrawerBackdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: rgba(0, 0, 0, 0.5);
}

.mobileDrawer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(255, 255, 255, 0.04);
  transition: transform 0.3s ease-out;
}

.mobileDrawerOpen { transform: translateX(0); }
.mobileDrawerClosed { transform: translateX(-100%); }

@media (min-width: 1024px) {
  .mobileDrawerBackdrop,
  .mobileDrawer { display: none; }
}

.tabletSidebar {
  display: none;
  flex-shrink: 0;
  height: 100%;
  transition: all 0.3s ease-out;
  overflow: hidden;
}

.tabletSidebarOpen { width: 240px; }
.tabletSidebarClosed { width: 0; }

@media (min-width: 640px) and (max-width: 1023px) {
  .tabletSidebar { display: flex; }
}

.mainContent {
  flex: 1;
  overflow-y: auto;
  background: #0F1424;
  padding-bottom: 80px;
  position: relative;
}

@media (min-width: 1024px) {
  .mainContent { padding-bottom: 0; }
}

.mainContentInner {
  min-height: 100%;
  padding: 16px;
  position: relative;
}

@media (min-width: 640px) {
  .mainContentInner { padding: 24px; }
}

.desktopAIPanel {
  display: none;
  flex-shrink: 0;
}

@media (min-width: 1024px) {
  .desktopAIPanel { display: flex; }
}

/* Error boundary */
.errorBoundary {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  text-align: center;
}

.errorCard {
  background: #0D1020;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 32px;
  max-width: 400px;
}

.errorTitle {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.errorMessage {
  color: #8B92A8;
  font-size: 13.5px;
  margin-bottom: 16px;
}

.errorRetryBtn {
  padding: 8px 16px;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 100%);
  color: #0A0E1A;
  font-weight: 600;
  font-size: 13.5px;
  font-family: inherit;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.errorRetryBtn:hover {
  box-shadow: 0 2px 16px rgba(0, 210, 106, 0.2);
}

/* ─── AI Panel ─── */
.aiBackdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: rgba(0, 0, 0, 0.5);
}

@media (min-width: 1024px) {
  .aiBackdrop { display: none; }
}

.aiPanel {
  display: flex;
  flex-direction: column;
  background: #0D1020;
  border-left: 1px solid rgba(255, 255, 255, 0.04);
  position: fixed;
  inset: 0;
  z-index: 50;
}

@media (min-width: 1024px) {
  .aiPanel {
    position: static;
    inset: auto;
    z-index: auto;
    width: 380px;
    flex-shrink: 0;
  }
}

.aiHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  flex-shrink: 0;
}

.aiHeaderIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(123, 92, 250, 0.15);
  color: #7B5CFA;
}

.aiHeaderTitle {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.aiCloseBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: none;
  background: none;
  color: #8B92A8;
  cursor: pointer;
  transition: all 0.15s ease;
}

.aiCloseBtn:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.04);
}

/* Tool selector */
.aiToolSelector {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  flex-shrink: 0;
  position: relative;
}

.aiToolBtn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  font-size: 13.5px;
  font-family: inherit;
  color: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
}

.aiToolBtn:hover {
  border-color: rgba(123, 92, 250, 0.4);
}

.aiToolBtnIcon {
  color: #7B5CFA;
  flex-shrink: 0;
}

.aiToolBtnLabel {
  flex: 1;
  text-align: left;
  font-weight: 500;
}

.aiToolBtnChevron {
  color: #555C72;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}

.aiToolBtnChevronOpen {
  transform: rotate(180deg);
}

.aiToolDropdownBackdrop {
  position: fixed;
  inset: 0;
  z-index: 10;
}

.aiToolDropdown {
  position: absolute;
  left: 16px;
  right: 16px;
  top: 100%;
  margin-top: 4px;
  z-index: 20;
  background: #0D1020;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 14px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.aiToolOption {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  background: none;
  border: none;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}

.aiToolOption:hover {
  background: rgba(255, 255, 255, 0.03);
}

.aiToolOptionActive {
  background: rgba(123, 92, 250, 0.08);
}

.aiToolOptionIcon {
  flex-shrink: 0;
  color: #555C72;
}

.aiToolOptionIconActive {
  color: #7B5CFA;
}

.aiToolOptionName {
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}

.aiToolOptionNameActive {
  color: #7B5CFA;
}

.aiToolOptionDesc {
  font-size: 10px;
  color: #555C72;
}

.aiToolOptionBadge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 6px;
  background: rgba(0, 210, 106, 0.1);
  color: #00D26A;
  flex-shrink: 0;
}

/* Context indicator */
.aiContext {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(123, 92, 250, 0.04);
  border-bottom: 1px solid rgba(123, 92, 250, 0.08);
  flex-shrink: 0;
}

.aiContextText {
  font-size: 11px;
  color: #a89df5;
}

/* Messages */
.aiMessages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.aiMsgRow {
  display: flex;
  gap: 12px;
}

.aiMsgRowUser {
  justify-content: flex-end;
}

.aiAvatar {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(123, 92, 250, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7B5CFA;
}

.aiMsgBubble {
  max-width: 85%;
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 13.5px;
  line-height: 1.5;
}

.aiMsgAssistant {
  background: #0D1020;
  color: #CBD5E1;
  border-top-left-radius: 4px;
}

.aiMsgUser {
  background: #00D26A;
  color: #0A0E1A;
  font-weight: 500;
  border-top-right-radius: 4px;
}

/* Loading dots */
.aiLoadingDots {
  display: flex;
  gap: 4px;
  align-items: center;
  height: 16px;
}

.aiLoadingDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #7B5CFA;
  animation: aiBounce 1.4s infinite ease-in-out;
}

.aiLoadingDot:nth-child(2) { animation-delay: 0.15s; }
.aiLoadingDot:nth-child(3) { animation-delay: 0.3s; }

@keyframes aiBounce {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
  40% { transform: scale(1); opacity: 1; }
}

/* Suggested prompts */
.aiSuggested {
  padding: 0 16px 8px;
  flex-shrink: 0;
}

.aiSuggestedLabel {
  font-size: 10px;
  color: #555C72;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  margin-bottom: 8px;
}

.aiSuggestedBtn {
  display: block;
  width: 100%;
  text-align: left;
  font-size: 12px;
  font-family: inherit;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  color: #8B92A8;
  cursor: pointer;
  transition: all 0.15s ease;
  margin-bottom: 6px;
}

.aiSuggestedBtn:hover {
  color: #fff;
  border-color: rgba(123, 92, 250, 0.35);
  background: rgba(123, 92, 250, 0.04);
}

/* Input area */
.aiInputArea {
  padding: 8px 16px 16px;
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
}

.aiInputWrap {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  background: #0F1424;
  transition: all 0.15s ease;
}

.aiInputWrap:focus-within {
  border-color: rgba(0, 210, 106, 0.4);
  box-shadow: 0 0 0 3px rgba(0, 210, 106, 0.06);
}

.aiInputField {
  flex: 1;
  resize: none;
  background: transparent;
  padding: 12px;
  font-size: 13.5px;
  font-family: inherit;
  color: #fff;
  border: none;
  outline: none;
  line-height: 1.5;
  max-height: 128px;
  overflow-y: auto;
}

.aiInputField::placeholder {
  color: #555C72;
}

.aiSendBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 0 6px 6px 0;
  border-radius: 10px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #00D26A 0%, #14B8A6 100%);
  color: #0A0E1A;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.aiSendBtn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.aiSendBtn:not(:disabled):hover {
  box-shadow: 0 2px 12px rgba(0, 210, 106, 0.2);
}

.aiUpgradeHint {
  font-size: 10px;
  color: #555C72;
  text-align: center;
  margin-top: 8px;
}
